<template>
  <v-card tile class="pr-5 pb-2 pt-2 pl-2" style="width: 100%; height: 290px;">
    <v-card-text class="pa-0">
      <v-data-table
        :headers="dataTableHeaders"
        :items="dataTableData"
        hide-default-footer
        class="text-no-wrap"
        style="width: 100%; min-width: 0;overflow-y: auto; height: 270px;"
      >
        <template v-slot:item="{ item, index }">
          <tr style="cursor: pointer;" @click="onRowClicked(item.device_token)">
            <td
              v-for="header in dataTableHeaders"
              :key="header.value + index.toString()"
              :style="
                `color: ${item.color}; fontWeight: bold; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 0; min-width: 0;`
              "
            >
              {{ item[header.value] }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "MultiDeviceLegend",
  data() {
    return {
      dataTableHeaders: [
        { text: "Partial token", value: "partial_token" },
        { text: "Site Name", value: "device_name" },
        { text: "Address", value: "address" },
        { text: "City", value: "city" },
        { text: "State", value: "state" },
        { text: "Postcode", value: "postcode" }
      ]
    };
  },
  computed: {
    dataTableData() {
      return this.$store.state.devices.map((item, idx) => {
        const device = Object.assign({}, item);

        // get the trace color from the graph
        // there is only one chart group so grab the first one
        if (
          this.$store.state.chartGroup[0] &&
          this.$store.state.chartGroup[0].series[device.partial_token]
        ) {
          device.color = this.$store.state.chartGroup[0].series[
            device.partial_token
          ].color;
        } else {
          device.color = "red";
        }

        return device;
      });
    }
  },
  methods: {
    onRowClicked(device_token) {
      const devices = this.$store.state.devices;
      const foundDevice = devices.find(device =>
        device.device_token.endsWith(device_token)
      );
      if (foundDevice) {
        // Go to the found device
        this.$router.push("/deviceinfo/" + foundDevice.id);
      }
    }
  }
};
</script>
